import React from "react";

function About() {
  return (
    <section id="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="contact-info">
            <div className="contact-item"><strong>📍 Location:</strong><span>Jamshedpur, Jharkhand, India</span></div>
            <div className="contact-item"><strong>📧 Email:</strong><span>anshurajwork@gmail.com</span></div>
            <div className="contact-item"><strong>🎓 Institute Email:</strong><span>2023ugme058@nitjsr.ac.in</span></div>
            <div className="contact-item"><strong>📱 Phone:</strong><span>+91 9939747627</span></div>
            <div className="contact-item"><strong>🔗 LinkedIn:</strong><span>linkedin.com/in/anshu-raj-142b55253</span></div>
            <div className="contact-item"><strong>💻 GitHub:</strong><span>github.com/MrAnshuRaj</span></div>
          </div>
          <div className="about-info">
            <h3>Mechanical Engineering Student & Tech Innovator</h3>
            <p>
              I'm a highly technical and dedicated developer currently pursuing B.Tech in Mechanical Engineering at NIT Jamshedpur.
              With a passion for both traditional engineering and modern technology, I bridge the gap between mechanical systems and digital solutions.
            </p>
            <p>
              My expertise spans Android development, game development using Unity, web technologies, Firebase integration, and API development.
            </p>
            <p>
              As a co-founder of Petaverse (Institute Funded Startup) and Joint Secretary of the Soft Skills Club,
              I lead teams and coordinate events that foster innovation and professional development.
            </p>
            <p>
              Known for being hardworking and detail-oriented, I deliver high-quality applications while maintaining strong problem-solving skills.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
